import { observable, action } from "mobx";
import { makeApi, URLS } from "Utils/apiURL";
import { toasterState } from "Components/common/toaster";
import { seqTemplatePopupState } from "./SequenePredefinedTemplate/SeqTemplatePopupState";

class LinkedInTemplatePopupState {
  @observable showPopup = false;
  @observable showTemplatesListPopup = false;
  @observable templates = [];
  @observable templatesLoader = false;
  @observable applyTemplateLoader = false;
  @observable targetSequenceId = "";
  @observable selectedTemplate = null;
  @observable manualCallback = () => { };
  @observable reloadSequenceCallback = () => { };

  constructor() {
  }

  @action
  setShowPopup = (val = false) => {
    this.showPopup = val;
    this.handleScroll(val);
  };

  @action
  setShowTemplatesListPopup = (val = false) => {
    this.showTemplatesListPopup = val;
    this.handleScroll(val);
  };

  @action
  setManualCallback = (cb = () => { }) => {
    this.manualCallback = cb;
  };

  @action
  setTargetSequenceId = (id = "") => {
    this.targetSequenceId = id;
  };

  @action
  setReloadSequenceCallback = (cb = () => { }) => {
    this.reloadSequenceCallback = cb;
  };

  @action
  setSelectedTemplate = (template = null) => {
    this.selectedTemplate = template;
  };

  @action
  fetchLinkedInTemplates = async () => {
    try {
      this.templatesLoader = true;
      const config = {
        url: URLS.getDefaultLinkedInTemplates || "",
        method: "POST",
        data: { type: "LINKEDIN" }
      };
      const res = await makeApi(config);
      if (res && res.data) {
        this.templates = Array.isArray(res.data) ? res.data : [];
      } else {
        this.templates = [];
      }
    } catch (e) {
      console.error("Error fetching LinkedIn templates:", e);
      this.templates = [];
    } finally {
      this.templatesLoader = false;
    }
  };

  @action
  applyLinkedInTemplate = async (templateId, folderId, history) => {
    try {
      const id =
        templateId || this.selectedTemplate?._id || this.selectedTemplate?.id;
      if (!id) {
        toasterState.setToastMsg("Please select a template", "failure");
        return;
      }
      this.applyTemplateLoader = true;
      const config = {
        url: URLS.applyLinkedInTemplate || "",
        method: "POST",
        data: {
          templateId: id,
          ...(this.targetSequenceId && { targetSequenceId: this.targetSequenceId }),
          ...(folderId && { folderId: folderId })
        }
      };
      const res = await makeApi(config);
      if (res && res.status === 200) {
        toasterState.setToastMsg("Template applied successfully", "success");
        this.setShowTemplatesListPopup(false);
        this.setSelectedTemplate(null);
        seqTemplatePopupState.setAction("");

        if (res?.data?.id && history) {
          const targetFolderId = folderId && folderId !== "" ? folderId : "all";
          history.push(
            `/sequences/${targetFolderId}/${res.data.id}`
          );
        } else if (this.reloadSequenceCallback) {
          this.reloadSequenceCallback();
        }
      } else {
        toasterState.setToastMsg(
          res?.message || "Failed to apply template",
          "failure"
        );
      }
    } catch (e) {
      console.error("Error applying LinkedIn template:", e);
      toasterState.setToastMsg("Error applying template", "failure");
    } finally {
      this.applyTemplateLoader = false;
    }
  };

  handleScroll = (val) => {
    if (val) {
      document.getElementsByTagName("body")[0].classList.add("scrollHidden");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("scrollHidden");
    }
  }
}

const linkedInTemplatePopupState = new LinkedInTemplatePopupState();

export { linkedInTemplatePopupState };
export default linkedInTemplatePopupState;

